import { render, staticRenderFns } from "./TeamLogs.vue?vue&type=template&id=0a1c57bd&scoped=true"
import script from "./TeamLogs.vue?vue&type=script&lang=ts"
export * from "./TeamLogs.vue?vue&type=script&lang=ts"
import style0 from "./TeamLogs.vue?vue&type=style&index=0&id=0a1c57bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1c57bd",
  null
  
)

export default component.exports